import { useEffect, useRef, useState } from 'react';

export const useClampOverflow = <
  T extends HTMLParagraphElement = HTMLParagraphElement,
>(
  enabled: boolean = true
) => {
  const ref = useRef<T | null>(null);
  const [clamped, setClamped] = useState(false);

  useEffect(() => {
    if (!enabled) return;

    const el = ref.current;
    if (!el) return;

    const measure = () => setClamped(el.scrollHeight > el.clientHeight + 1);

    const ro = new ResizeObserver(measure);
    ro.observe(el);

    return () => ro.disconnect();
  }, [enabled]);

  return { ref, clamped };
};
